module.exports = __webpack_public_path__ + "static/img/SFU老师_Steve.30c5964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Steve.png
// module id = 7Ue5
// module chunks = 0